module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av135-4adc925e1ea9f6a509aad1ee1b1cd655.jpg";